import {useTranslation} from "react-i18next";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import {useNavigate} from "react-router-dom";
import {Machine} from "../../../../models/machine.models";

export const MachineContactsManagementAction: React.FC<Machine> = (props) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {id, friendlyName, organizationUnitId, organizationId} = props;

    const navigateTo = () => {
        if (!!id && !!organizationUnitId) {
            const path = `/organization-units/${organizationUnitId}/machines/${id}/contacts`;
            const queryParams = `machineName=${friendlyName}&organizationId=${organizationId}`;
            return navigate(`${path}?${queryParams}`);
        }
    };

    return (
        <ListItem>
            <ListItemText style={{cursor: 'pointer'}} onClick={navigateTo}>
                {t('Machine.Actions.ManageContacts')}
            </ListItemText>
        </ListItem>);
};
